








































































































































































































































































































































import router from "@/router";
import {
  ICouponList,
  ICouponMessage,
  IFilters,
  IPagination,
  IUserData,
} from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import TopListCoupons from "@/components/TopListCoupons.vue";
import DialogCoupon from "@/components/DialogCoupon.vue";
import DialogDetails from "@/components/DialogDetails.vue";

@Component({
  components: {
    TopListCoupons,
    DialogCoupon,
    DialogDetails,
  },
})
export default class ListCoupons extends Vue {
  @Prop() readonly session!: string;

  @Action("loadCoupons", { namespace: "coupon" }) loadCoupons!: (
    filters: IFilters
  ) => Promise<boolean>;

  @Getter("getCouponsList", { namespace: "coupon" }) coupons!: ICouponList[];
  @Getter("getPaginate", { namespace: "coupon" }) paginate!: IPagination;
  @Getter("getTypesCoupon", { namespace: "coupon" }) typesCoupon!: string[];


  @Mutation("setUserData", { namespace: "coupon" }) setUserData!: (
    params: IUserData
  ) => void;

  @Mutation("setCouponsUndefined", { namespace: "coupon" })
  setCouponsUndefined!: () => void;

  @Mutation("setPage", { namespace: "coupon" })
  setPage!: (page: number) => void;

  @Watch("paginate.per_page")
  onPaginatePerPageChange(): void {
    this.getCupons(this.paginate.page);
  }
  amountPerPage = [10, 20, 50, 70];
  listStatus = ['TODOS', 'PENDENTE', 'APROVADO', 'REPROVADO', 'NEGOCIADO', 'P/ DIRETORIA']

  headers = [
    {
      text: "Código do Cupom",
      show: true,
    },
    {
      text: "Valor Orçamento",
      show: false,
    },
    {
      text: "Tipo de Cupom",
      show: true,
    },
    {
      text: "Tipo do Gerador",
      show: false,
    },
    {
      text: "Desconto Inicial Pelo Consultor",
      show: true,
    },
    {
      text: "Desconto Aprovado",
      show: true,
    },
    {
      text: "Total do Desconto Concedido",
      show: true,
    },
    {
      text: "Nome do Responsável",
      show: false,
    },
    {
      text: "Nome do Integrador",
      show: false,
    },
    {
      text: "Status",
      show: true,
    },
    {
      text: "Usado",
      show: true,
    },
    {
      text: "Filial",
      show: true,
    }
  ];

  overlay = false;
  dialog = false;
  couponId = 0;
  dialogDetails = false;
  message: ICouponMessage = {
    title: "Erro!",
    body: "Nenhum registro encontrado.",
  };

  filters: IFilters = {
    findGeneratedId: "",
    findBudgetId: "",
    findAdminId: "",
    findAdminName: "",
    findAdminTradeName: "",
    findRuleId: "",
    findDiscount: "",
    findCouponCode: "",
    findCouponType: "",
    findBudgetMin: "",
    findBudgetMax: "",
    findDiscountMax: "",
    findDiscountMin: "",
    findStatus: "",
  };

  mounted(): void {
    const userData: IUserData = {
      role: 0,
      session: this.session,
      rca_id: 0,
    };

    this.setCouponsUndefined();
    this.loadCoupons(this.filters);
    this.getCupons(1);

    this.setUserData(userData);
  }

  public calcPercentBudget(budget_value:number, value:number): any{
    let discount = ((100*value)/budget_value).toFixed(2)
    return discount
  }

  public cleanFilter() {
    this.filters.findGeneratedId = ""
    this.filters.findBudgetId = ""
    this.filters.findAdminId = ""
    this.filters.findAdminName = ""
    this.filters.findAdminTradeName = ""
    this.filters.findRuleId = ""
    this.filters.findDiscount = ""
    this.filters.findCouponCode = ""
    this.filters.findCouponType = ""
    this.filters.findBudgetMin = ""
    this.filters.findBudgetMax = ""
    this.filters.findDiscountMax = ""
    this.filters.findDiscountMin = ""
    this.filters.findStatus = ""
    this.getCupons(1);
  }

  public async getCupons(page: number): Promise<void> {
    this.overlay = true;
    this.setPage(page);
    await this.loadCoupons(this.filters).then((value: boolean) => {
      if (value && this.coupons.length < 0) {
        this.dialog = true;
        this.setCouponsUndefined();
        this.overlay = false;
      } else if (value) {
        this.overlay = false;
      } else {
        this.$router.replace("/");
      }
    });
  }

  public closeDialog(): void {
    this.dialog = false;
  }

  public closeDialogDetails(): void {
    this.dialogDetails = false;
  }

  public redirectNewCoupon(): void {
    router.replace(`/${this.session}`);
  }

  public definedStatus(coupon:any) :string{
    if(coupon.status == 'APROVADO'){
      if(coupon.initial_discount != coupon.discount_total ){
        return "NEGOCIADO"
      }else{
        return coupon.status
      }
    }else{
      return coupon.status
    }
  }
}
